import { useNavigate } from "react-router-dom";
import { POPUP_CLOSE_TIME } from "../../../../constant/constant";
import useDeleteClassroom from "../../../../hooks/teacher/classroom/useDeleteClassroom";
import { useState } from "react";
import DeleteModal from "../../../common/DeleteModal";
import RoleGuard from "../../../auth/RoleGuard";

/**
 * @typedef {import("../../../../hooks/teacher/classroom/useGetAllClassrooms").ClassroomType} ClassroomType
 */

/**
 *
 * @param {Object} classroomParams
 * @param {ClassroomType} classroomParams.classroom
 * @param {()=> void} classroomParams.refetch
 * @param {boolean} classroomParams.disabled
 * @param {string} classroomParams.type
 * @returns
 */
const ClassroomTableRow = ({ classroom, refetch, disabled, type }) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const { deleteClassroom, loading, error, success } = useDeleteClassroom();
  const navigate = useNavigate();

  const handleDeleteModal = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setDeleteModal(!deleteModal);
  };

  const handleDelete = async () => {
    await deleteClassroom({
      classroomId: classroom?.id,
      onSuccess: () => {
        setTimeout(() => {
          setDeleteModal(false);
          refetch();
        }, POPUP_CLOSE_TIME);
      },
    });
  };
  const handleEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (type === "school-admin") {
      navigate(`/school-admin/classroom/update/${classroom.id}`);
    } else {
      navigate(`/teacher/classroom/update/${classroom.id}`);
    }
  };

  const handleReport = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (type === "school-admin") {
      navigate(`/school-admin/classroom/report/${classroom.id}`, {
        state: {
          classroomName: classroom.name,
        },
      });
    } else {
      navigate(`/teacher/classroom/report/${classroom.id}`, {
        state: {
          classroomName: classroom.name,
        },
      });
    }
  };

  return (
    <>
      <tr
        className=""
        onClick={() => {
          if (type === "school-admin") {
            navigate(`/school-admin/classroom/detail/${classroom?.id}`, {
              state: {
                classroomName: classroom.name,
              },
            });
          } else {
            navigate(`/teacher/classroom/detail/${classroom?.id}`, {
              state: {
                classroomName: classroom.name,
              },
            });
          }
        }}
        style={{
          cursor: "pointer",
        }}
      >
        <td>{classroom?.name}</td>
        <td>{classroom?.total_students}</td>
        <td>{classroom?.total_lessons}</td>
        {/* <td className="custom-progress-cell">
          {classroom?.status === "1" ? (
            <span className="badge bg-success">Active</span>
          ) : (
            <span className="badge bg-secondary">Inactive</span>
          )}
        </td> */}
        <RoleGuard permission="dashboard_edit_delete_classroom">
          <td className="d-flex" style={{ gap: "0px" }}>
            {/* Action buttons */}
            <RoleGuard permission="dashboard_edit_classroom">
              <button
                className="action-delete-edit-btn"
                onClick={handleEdit}
                disabled={disabled}
                title="Edit Classroom"
              >
                <i className="bi bi-pencil-square"></i>
              </button>
            </RoleGuard>
            <RoleGuard permission="dashboard_delete_classroom">
              <button
                className="action-delete-edit-btn"
                onClick={handleDeleteModal}
                disabled={disabled}
                title="Delete Classroom"
              >
                <i className="bi bi-trash"></i>
              </button>
            </RoleGuard>
            <RoleGuard permission="dashboard_classroom_report">
              <button
                className="action-delete-edit-btn"
                onClick={handleReport}
                disabled={disabled}
                title="View Report"
              >
                <i className="bi bi-file-earmark-bar-graph"></i>
              </button>
            </RoleGuard>
          </td>
        </RoleGuard>
      </tr>
      <DeleteModal
        message="Are you sure you want to delete this classroom?"
        showModal={deleteModal}
        handleClose={() => setDeleteModal(false)}
        handleDelete={handleDelete}
        loading={loading}
        errorMessage={error}
        successMessage="Classroom deleted successfully"
        success={success}
      />
    </>
  );
};

export default ClassroomTableRow;
